<template>
  <div class="h">
    <div class="logo">
      <p>身份证数据服务平台</p>
    </div>
    <div class="control">
      <el-dropdown trigger="click" @command="handleCommand">
        <el-button type="primary">
          {{user_name}}<i class="el-icon-caret-bottom el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="loadCloud">云端管家</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
  import axios from "axios"

  export default {
    name: "Header",
    data() {
      return {
        user_name: ""
      }
    },
    created() {
      this.loadInfo();
    },
    methods: {
      loadInfo() {
        axios.get("/info/").then(resp => this.user_name = resp.data.info.user_name)
      },
      handleCommand(command) {
        switch (command) {
          case "loadCloud":
            window.location.href = "http://cloud.jj-robot.com";
            break;
        }
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../share/styles/colors.styl"

  .h
    height 100%
    background-color baseBlue
    display flex
    justify-content space-between
    align-items center

    & .logo
      display flex
      min-width 200px
      height 50px
      margin-left 50px
      & p
        margin auto
        color white
        font-size 1.2em

    & .control
      display inline-block
      min-width 150px
      height 50px

      & .el-button
        background-color baseBlue
        border-color baseBlue
</style>



// WEBPACK FOOTER //
// src/components/Header.vue